var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon__youtube",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.215 2.186A2.505 2.505 0 0 0 18.446.418C16.887 0 10.633 0 10.633 0S4.378 0 2.819.418a2.505 2.505 0 0 0-1.768 1.768C.633 3.745.633 7 .633 7s0 3.255.418 4.814c.23.86.907 1.537 1.768 1.768C4.38 14 10.633 14 10.633 14s6.254 0 7.813-.418a2.504 2.504 0 0 0 1.769-1.768c.418-1.56.418-4.814.418-4.814s-.002-3.255-.418-4.814Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m8.629 10 5.196-3-5.196-3v6Z"
})));
export default SvgYoutube;